import { TagsChooser } from "../TagsChooser";
import { useSearchContext } from "../../contexts";
import { useTranslation } from "react-i18next";
import { DropdownFilter } from "../../../../components/Filters/DropdownFilter";

interface TagsChooserDropdownProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const TagsChooserDropdown: React.FC<TagsChooserDropdownProps> = ({ onOpenChange }) => {
  const { state } = useSearchContext();
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("Actor tags")}
      counter={state.draftFilters.tags.value.length}
      isExclude={state.draftFilters.tags.exclude}
      onOpenChange={onOpenChange}
    >
      <TagsChooser />
    </DropdownFilter>
  );
};
